module.exports = __webpack_public_path__ + "media/images/billing/relax-bf6f130bc85a2123169d027905233fa6.svg";